module.exports = __webpack_public_path__ + "static/img/v3.64229f95.png";